export default __webpack_public_path__ + "static/national-2-regular-6a2af345258a6c3f3e1799a598df7a21.woff2";